"use client"

import { useActionState, useState } from "react"
import { creerDemande } from "@/app/actions/sur-mesure"
import { resizeImage } from "@/lib/images"
import { FormError, SubmitButton } from "./form"

export function CustomRequestForm() {
  const [state, dispatch] = useActionState(creerDemande, undefined)
  const [files, setFiles] = useState<File[]>([])
  const [preparing, setPreparing] = useState(false)

  const onFiles = async (list: FileList | null) => {
    if (!list) return
    setPreparing(true)
    const resized = await Promise.all([...list].slice(0, 4).map((f) => resizeImage(f, 1600)))
    setFiles(resized)
    setPreparing(false)
  }

  return (
    <form
      action={(fd) => {
        fd.delete("photos")
        files.forEach((f) => fd.append("photos", f))
        dispatch(fd)
      }}
      className="grid gap-5"
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="name" className="etiquette">Votre nom</label>
          <input id="name" name="name" required className="champ" autoComplete="name" />
        </div>
        <div>
          <label htmlFor="email" className="etiquette">E-mail</label>
          <input id="email" name="email" type="email" required className="champ" autoComplete="email" />
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="phone" className="etiquette">Téléphone (facultatif)</label>
          <input id="phone" name="phone" type="tel" className="champ" autoComplete="tel" />
        </div>
        <div>
          <label htmlFor="object_type" className="etiquette">Type d’objet</label>
          <select id="object_type" name="object_type" className="champ" defaultValue="">
            <option value="">Je ne sais pas encore</option>
            <option>Céramique (assiettes, bols, tasses…)</option>
            <option>Aquarelle ou dessin</option>
            <option>Objet en bois</option>
            <option>Autre</option>
          </select>
        </div>
      </div>
      <div>
        <label htmlFor="description" className="etiquette">Votre projet</label>
        <textarea id="description" name="description" required className="champ !min-h-40" placeholder="L’objet, les couleurs, un prénom ou une date, l’usage, l’occasion…" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="budget" className="etiquette">Budget indicatif (facultatif)</label>
          <input id="budget" name="budget" className="champ" />
        </div>
        <div>
          <label htmlFor="desired_date" className="etiquette">Pour quand ? (facultatif)</label>
          <input id="desired_date" name="desired_date" className="champ" placeholder="ex. avant la mi-décembre" />
        </div>
      </div>
      <div>
        <label htmlFor="photos" className="etiquette">Photos d’inspiration (facultatif, 4 au plus)</label>
        <input id="photos" name="photos" type="file" accept="image/*" multiple onChange={(e) => onFiles(e.target.files)} className="champ !py-3" />
        {preparing && <p className="aide">Préparation des photos…</p>}
        {files.length > 0 && !preparing && <p className="aide">{files.length} photo{files.length > 1 ? "s" : ""} prête{files.length > 1 ? "s" : ""}.</p>}
      </div>
      <FormError state={state} />
      <SubmitButton className="bouton w-full sm:w-auto" pending="Envoi…" disabled={preparing}>
        Envoyer ma demande
      </SubmitButton>
      <p className="aide">Vous recevrez un lien personnel pour suivre nos échanges et retrouver le devis.</p>
    </form>
  )
}
